module.exports = __webpack_public_path__ + "img/channel-sidebar-act.3786d903.svg";